import {IRouteStore} from '../../router/routing.infra';
import {IInvitationEndedController} from './controller';

export interface IInvitationEndedStore extends IRouteStore {
    invitationEndedController: IInvitationEndedController;
    dispose(): void;
}

export class InvitationEndedStore implements IInvitationEndedStore {
    constructor(public invitationEndedController: IInvitationEndedController) {}

    dispose(): void {}
}
